// src/pages/Success.js
import React, { useEffect, useRef, useContext } from "react";
import { useLocation } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import SEO from "../components/SEO";
import confetti from "canvas-confetti";
import { CartContext } from "../context/CartContext"; 
import "./Success.css";

const Success = () => {
  const location = useLocation();
  const { clearCart } = useContext(CartContext);
  const h1Ref = useRef(null);

  useEffect(() => {
    // Stripe only redirects here after a completed payment, so reaching this
    // page is the confirmation. Stripe emails the receipt directly.
    const query = new URLSearchParams(location.search);
    const sessionId = query.get("session_id");

    if (typeof window.gtag === "function") {
      window.gtag("event", "purchase", {
        transaction_id: sessionId || undefined,
        currency: "USD",
      });
    }

    clearCart();

    // 🎉 Trigger Confetti from h1 Text Position
    setTimeout(() => {
      if (h1Ref.current) {
        const rect = h1Ref.current.getBoundingClientRect();
        const originX = (rect.left + rect.width / 2) / window.innerWidth;
        const originY = (rect.top + rect.height / 2) / window.innerHeight;

        confetti({
          particleCount: 200,
          spread: 100,
          startVelocity: 40,
          origin: { x: originX, y: originY },
        });

      }
    }, 500); 

  }, [location.search, clearCart]);

  return (
    <div>
      <SEO
        title="Order Confirmed"
        description="Your Brik order is confirmed."
        path="/success"
        robots="noindex, nofollow"
      />
      <Header />
      <div className="success-container">
        <h1 ref={h1Ref}>Order Confirmed!</h1> {/* Reference added */}
        <p>Thank you for your purchase.</p>
        <p>Your order has been confirmed and is being processed.</p>
        <p>You will receive a receipt by email shortly with your order details.</p>
        <p>Please check your spam folder if you have not received it yet.</p>
      </div>
      <Footer />
    </div>
  );
};

export default Success;
